import { useUserIdentityState, userIdentityManager } from '@provider/user-identity';
import { LogoutIcon } from '@ui/kit/icons';
import { nameCls, logoutCls } from './atom.user.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const User = () => {
  const user = useUserIdentityState(state => state.user);
  return /*#__PURE__*/jsxs("section", {
    children: [/*#__PURE__*/jsx("span", {
      className: nameCls,
      children: user?.name
    }), /*#__PURE__*/jsxs("button", {
      className: logoutCls,
      onClick: user ? userIdentityManager.logout : userIdentityManager.requestLogin,
      children: [/*#__PURE__*/jsx(LogoutIcon, {}), /*#__PURE__*/jsxs("span", {
        children: ["Log ", user ? "ud" : "ind"]
      })]
    })]
  });
};

export { User };
//# sourceMappingURL=atom.user.js.map
